import { render, staticRenderFns } from "./DownloadMaterialsTop.vue?vue&type=template&id=4419de32&"
import script from "./DownloadMaterialsTop.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterialsTop.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMaterialsTop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports